import { hotRank, radarTags } from "@/mocks/homeData";

const catColor = [
  "bg-accent-100 text-accent-800",
  "bg-secondary-100 text-secondary-900",
  "bg-primary-100 text-primary-800",
];

export default function HotRank() {
  return (
    <section id="hot" className="border-y border-background-200 bg-background-100/70">
      <div className="mx-auto max-w-6xl px-4 py-7 md:px-6 md:py-10">
        <div className="mb-5 flex items-end justify-between gap-3">
          <div className="flex items-center gap-3">
            <span className="h-6 w-1.5 rounded-full bg-accent-500" />
            <div>
              <p className="font-label text-[11px] font-medium tracking-[0.28em] text-foreground-400">
                讨论热度 · TRENDING
              </p>
              <h2 className="mt-0.5 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                24h 热度榜
              </h2>
            </div>
          </div>
          <button
            type="button"
            className="inline-flex cursor-pointer items-center gap-1.5 rounded-full border border-background-300 px-3.5 py-1.5 text-sm text-foreground-600 whitespace-nowrap transition-colors hover:border-accent-300 hover:text-accent-700"
          >
            <i className="ri-refresh-line" />
            换一批
          </button>
        </div>

        <div className="grid gap-6 lg:grid-cols-3">
          {/* ranking list */}
          <div className="lg:col-span-2">
            <ul className="divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50">
              {hotRank.map((item) => {
                const topThree = item.id <= 3;
                return (
                  <li key={item.id} className="group flex cursor-pointer items-center gap-4 px-4 py-3 transition-colors hover:bg-background-100 md:px-5">
                    <span
                      className={`w-9 shrink-0 text-center font-heading text-xl font-black leading-none md:text-2xl ${
                        topThree ? "text-accent-600" : "text-foreground-300"
                      }`}
                    >
                      {item.id}
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-semibold text-foreground-900 transition-colors group-hover:text-accent-800 md:text-[15px]">
                        {item.title}
                      </p>
                      <div className="mt-1.5 flex items-center gap-2">
                        <span className={`inline-flex shrink-0 items-center rounded px-1.5 py-px text-[11px] font-medium ${catColor[item.id % 3]}`}>
                          {item.tag}
                        </span>
                        <div className="hidden h-1 flex-1 overflow-hidden rounded-full bg-background-200 sm:block">
                          <div
                            className="h-full rounded-full bg-accent-500/80"
                            style={{ width: `${item.heat}%` }}
                          />
                        </div>
                        <span className="shrink-0 text-[11px] text-foreground-400">{item.heat}°C</span>
                      </div>
                    </div>
                    <span
                      className={`hidden shrink-0 items-center gap-1 text-[11px] md:inline-flex ${
                        item.delta >= 0 ? "text-accent-600" : "text-secondary-700"
                      }`}
                    >
                      <i className={item.delta >= 0 ? "ri-arrow-up-line" : "ri-arrow-down-line"} />
                      {Math.abs(item.delta)}
                    </span>
                    <i className="ri-arrow-right-line hidden shrink-0 text-foreground-300 transition-transform group-hover:translate-x-1 group-hover:text-accent-600 md:block" />
                  </li>
                );
              })}
            </ul>
          </div>

          {/* radar panel */}
          <aside className="flex flex-col">
            <div className="rounded-lg border border-background-200 bg-gradient-to-b from-background-50 to-background-100 p-5">
              <div className="mb-4 flex items-center justify-between">
                <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <i className="ri-radar-line text-accent-600" />
                  话题雷达
                </h3>
                <span className="text-[11px] text-foreground-400">热度由强到弱</span>
              </div>
              <div className="flex flex-wrap gap-2">
                {radarTags.map((tag, i) => {
                  const level = i % 3;
                  const cls =
                    level === 0
                      ? "border-accent-200 bg-accent-50 text-accent-800"
                      : level === 1
                        ? "border-secondary-200 bg-secondary-50 text-secondary-900"
                        : "border-background-200 bg-background-100 text-foreground-700";
                  const size = level === 0 ? "px-3 py-1.5 text-[13px] font-semibold" : "px-2.5 py-1 text-xs";
                  return (
                    <button
                      key={tag}
                      type="button"
                      className={`inline-flex cursor-pointer items-center gap-1 rounded-full border ${cls} ${size} whitespace-nowrap transition-transform hover:-translate-y-0.5`}
                    >
                      {level === 0 && <i className="ri-fire-fill text-[11px]" />}
                      {tag}
                    </button>
                  );
                })}
              </div>
            </div>

            <div className="mt-4 rounded-lg border border-primary-800 bg-primary-950 p-5 text-background-50">
              <p className="flex items-center gap-2 font-label text-[11px] font-bold tracking-[0.18em] text-accent-400">
                <i className="ri-seedling-line" />
                我们怎么测「热度」
              </p>
              <p className="mt-2 text-[13px] leading-relaxed text-foreground-100/75">
                综合检索量、评论区互动与多平台转载，用「°C」给话题一个可比较的读数，越高越值得今天跟进。
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}